import React from 'react';
import ListingProps, {ListingLayoutProps} from './props';

import ListingEnhanced from '../ListingEnhanced';
import ListingEnhancedProps from '../ListingEnhanced/props';
import ListingPremium from '../ListingPremium';
import ListingPremiumProps from '../ListingPremium/props';
import ListingSocial from '../ListingSocial';
import listingSocial from '../ListingSocial/props';
import ListingSponsored from '../ListingSponsored';
import ListingSponsoredProps from '../ListingSponsored/props';
import ListingStandard from '../ListingStandard';
import ListingStandardProps from '../ListingStandard/props';
import ListingPreviewCard from '../ListingPreviewCard';
import listingPreviewCard from '../ListingPreviewCard/props';
import ListingOem from '../ListingOem';
import ListingOemProps from '../ListingOem/props';
import {ListingLayout} from "./components/ListingLayout";

// Re-export ListingLayout and ListingLayoutProps to maintain API compatibility
export {ListingLayout};
export type {ListingLayoutProps};

/**
 * @deprecated This function is no longer needed. Use the individual Listing components instead.
 * We might also consider a simplification/unification of the different listings and a re-definition of the types.
 */
function Listing(props: ListingProps) {
  return <>
    {(!props.classNames || props.classNames?.standard) && <ListingStandard {...props as ListingStandardProps}></ListingStandard>}
    {props.classNames?.enhanced && <ListingEnhanced {...props as ListingEnhancedProps}></ListingEnhanced>}
    {props.classNames?.premium && <ListingPremium {...props as ListingPremiumProps}></ListingPremium>}
    {props.classNames?.sponsored && <ListingSponsored {...props as ListingSponsoredProps}></ListingSponsored>}
    {props.classNames?.oem && <ListingOem {...props as ListingOemProps}></ListingOem>}
    {props.classNames?.card && <ListingPreviewCard {...props as listingPreviewCard}></ListingPreviewCard>}
    {props.classNames?.social && <ListingSocial {...props as listingSocial}></ListingSocial>}
  </>;
}

export default React.memo(Listing);
